<template>
  <div class="mailing-staff-list-filters">
    <div class="mailing-staff-list-filters__first-line">
      <div class="mailing-staff-list-filters__filter">
        <div class="mailing-staff-list-filters__filter-label">
          {{ $t("labels.organization_structure") }}
        </div>
        <tree-select
          @checked="onOrgChecked"
          :placeholder="$t('labels.organizations')"
          :defaultCheckedKeys="filters.orgs"
          :data="departmensList"
          nodeKey="id"
          :props="{ label: 'name', children: 'children' }"
          multiselect
          ref="departmenList"
        >
        </tree-select>
      </div>
      <div class="mailing-staff-list-filters__filter">
        <div class="mailing-staff-list-filters__filter-label">
          <div class="mailing-staff-list-filters__filter-label">
            {{ $t("labels.position") }}
          </div>
          <!-- <el-input :placeholder="$t('labels.position')" v-model="filters.orgs_notes[0]" @input="onPostInput"></el-input> -->
          <el-select
            class="mailing-staff-list-filters__posts-select"
            v-model="filters.orgs_notes"
            multiple
            filterable
            allow-create
            default-first-option
            @change="onPostInput"
            popper-class="mailing-staff-list-filters__posts-popup"
            :placeholder="$t('labels.check_position')"
          >
            <el-option
              v-for="item in []"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="admin" class="mailing-staff-list-filters__filter">
        <div class="mailing-staff-list-filters__filter-label">
          {{ $t("labels.permitted_actions") }}
        </div>
        <el-select
          v-model="filters.roles"
          :popper-append-to-body="true"
          :placeholder="$t('labels.permitted_actions')"
          multiple
          @change="changed"
        >
          <el-option
            v-for="status in rolesList"
            :key="status.value"
            :label="status.name"
            :value="status.value"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="admin" class="mailing-staff-list-filters__filter">
        <div class="mailing-staff-list-filters__filter-label">
          {{ $t("labels.status_in_system") }}
        </div>
        <el-select
          v-model="filters.statuses"
          :popper-append-to-body="true"
          multiple
          :placeholder="$t('labels.status_in_system')"
          @change="changed"
        >
          <el-option
            v-for="status in statusesList"
            :key="status.value"
            :label="status.name"
            :value="status.value"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="admin" class="mailing-staff-list-filters__filter">
        <div class="mailing-staff-list-filters__filter-label">
          {{ $t("labels.cols.messengers") }}
        </div>
        <el-select
          v-model="filters.msgrs"
          :popper-append-to-body="true"
          multiple
          :placeholder="$t('labels.cols.messengers')"
          @change="changed"
        >
          <el-option
            v-for="msgr in msgrsList"
            :key="msgr.value"
            :label="msgr.name"
            :value="msgr.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import TreeSelect from "@/components/TreeSelect/TreeSelect";
import config from "@/config";

import {
  USER_STATUS_ACTIVE,
  USER_STATUS_CLOSED,
  USER_ROLE_ADMIN,
  USER_ROLE_ADMIN_LABEL,
  USER_ROLE_MAILING_LABEL,
  USER_ROLE_MAILING,
  USER_ROLE_STATS_LABEL,
  USER_ROLE_STATS,
  USER_ROLE_STUD_LABEL,
  USER_ROLE_STUD,
  USER_ROLE_WIKI_LABEL,
  USER_ROLE_WIKI,
  USER_ROLE_STUDAUTH,
  USER_ROLE_STUDAUTH_LABEL,
  USER_ROLE_CHAT,
  USER_ROLE_CHAT_LABEL,
  CONF_MESSENGER_VK,
  CONF_MESSENGER_TG,
  CONF_MESSENGER_VB,
  CONF_MESSENGER_TT,
  CONF_MESSENGER_MAX,
  MSGR_MAX,
  MSGR_VB,
  MSGR_VK,
  MSGR_TG,
  MSGR_TT,
  MSGR_DC,
  CONF_MESSENGER_DISCORD,
} from "@/constants";

let emptyFilters = {
  orgs: [],
  roles: [],
  statuses: [],
  orgs_notes: [],
  msgrs: [],
};

export default {
  name: "UserListFilters",
  components: { TreeSelect },
  data() {
    return {
      filters: _.clone(emptyFilters),
      rolesList: [
        {
          name: USER_ROLE_ADMIN_LABEL,
          value: USER_ROLE_ADMIN,
        },
        {
          name: USER_ROLE_MAILING_LABEL,
          value: USER_ROLE_MAILING,
        },
        {
          name: USER_ROLE_STATS_LABEL,
          value: USER_ROLE_STATS,
        },
        {
          name: USER_ROLE_STUD_LABEL,
          value: USER_ROLE_STUD,
        },
        {
          name: USER_ROLE_WIKI_LABEL,
          value: USER_ROLE_WIKI,
        },
        {
          name: USER_ROLE_STUDAUTH_LABEL,
          value: USER_ROLE_STUDAUTH,
        },
        {
          name: USER_ROLE_CHAT_LABEL,
          value: USER_ROLE_CHAT,
        },
      ],
      statusesList: [
        {
          name: this.$t("labels.status_active"),
          value: USER_STATUS_ACTIVE,
        },
        {
          name: this.$t("labels.status_closed"),
          value: USER_STATUS_CLOSED,
        },
      ],
      msgrsList: [],
      departmensList: [],
    };
  },
  async mounted() {
    /* this.$store.dispatch('users/loadPosts', true)
      this.$store.dispatch('users/loadDepartments', true)
      this.$store.dispatch('users/loadSpecialities', true)
      this.$store.dispatch('users/loadOnline', true)
      this.systemStatusPreset() */
    this.insertSocials();
    await this.getDepTree();
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    admin() {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN);
      }
      return false;
    },
  },
  methods: {
    insertSocials() {
      if (this.getActiveSocial(CONF_MESSENGER_VK)) {
        this.pushSocial(this.$t("common.socials.vk"), MSGR_VK);
      }
      if (this.getActiveSocial(CONF_MESSENGER_TG)) {
        this.pushSocial(this.$t("common.socials.tg"), MSGR_TG);
      }
      if (this.getActiveSocial(CONF_MESSENGER_VB)) {
        this.pushSocial(this.$t("common.socials.vb"), MSGR_VB);
      }
      if (this.getActiveSocial(CONF_MESSENGER_MAX)) {
        this.pushSocial('MAX', MSGR_MAX);
      }
      if (this.getActiveSocial(CONF_MESSENGER_TT)) {
        this.pushSocial(this.$t("common.socials.tt"), MSGR_TT);
      }
      if (this.getActiveSocial(CONF_MESSENGER_DISCORD)) {
        this.pushSocial(this.$t("common.socials.dc"), MSGR_DC);
      }
    },
    getActiveSocial(key) {
      return config(key) && config(key) === true;
    },
    pushSocial(name, value) {
      this.msgrsList.push({
        name: name,
        value: value,
      });
    },
    async getDepTree() {
      try {
        let list = await this.$store.dispatch("orgs/loadRawOrgList");
        let tree = this.$store.getters["orgs/getRawTree"](list);

        this.departmensList = tree;
      } catch (error) {
        console.error("LOG: getDepList -> error", error);
      }
    },
    changed() {
      let filters = {};
      for (const filter in this.filters) {
        if (this.filters.hasOwnProperty(filter)) {
          const element = this.filters[filter];
          if (element && element.length) {
            filters[filter] = element;
          }
        }
      }
      this.$emit("changed", filters);
    },
    onPostInput: _.debounce(function() {
      this.changed();
    }, 1000),
    getFilters() {
      let filters = {};
      for (let key in this.filters) {
        if (Array.isArray(this.filters[key]) && this.filters[key].length > 0) {
          filters[key] = _.clone(this.filters[key]);
        }
        if (
          !Array.isArray(this.filters[key]) &&
          this.filters[key].trim() !== ""
        ) {
          filters[key] = this.filters[key].trim();
        }
      }
      return filters;
    },
    reset() {
      this.$set(this, "filters", _.clone(emptyFilters));
      // this.systemStatusPreset()
      this.$refs.departmenList.reset();
      // this.$refs.specialitiesList.reset()
      // this.$refs.postsList.reset()
    },
    onOrgChecked(data, checked, data2, data3) {
      let keys = _.clone(checked.checkedKeys);
      if (data.id === "?" && keys.indexOf("?") !== -1) {
        keys = ["?"];
      } else if (keys.indexOf("?") !== -1) {
        keys.splice(keys.indexOf("?"), 1);
      }
      this.filters.orgs = keys;
      this.changed();
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/sass/core";

.mailing-staff-list-filters {
  padding: 20px;
  padding-bottom: 0;
  border-top: 1px solid #dcdfe6;

  &__first-line {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 15px;
    margin-bottom: 25px;

    @include respond-to(desktop) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include respond-to(tablet) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include respond-to(phone) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__second-line {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 40px;

    @media (max-width: $screen-sm) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .tree-select__input {
    max-width: none;
  }

  &__filter {
    .el-select {
      width: 100%;

      &__tags {
        overflow: hidden;
      }
    }
  }

  &__filter-label {
    margin-bottom: 5px;
    font-size: 14px;
    color: #333333;
  }

  &__posts-select {
    .el-input__suffix {
      display: none !important;
    }
  }

  &__posts-popup {
    display: none !important;
  }
}
</style>
